import { outsiderApiClient } from '../outsiderApiClient'

const ContactService = {
  sendContactMessage: (payload: any) => outsiderApiClient.post(`/api/send-message`, payload),
  subscribeMail: (payload: any) => outsiderApiClient.post(`/api/subscribe`, payload),
  confirmCode: (token: string) => outsiderApiClient.get(`/api/subscribe/confirm/${token}`),
}
export default ContactService
